module.exports = __webpack_public_path__ + "static/media/groupPardini.f323a6d7.svg";